// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ui9Qm","rootMobile":"styles_rootMobile__2dacz"};